/**
 * ThemeToggle — Sun/Moon switch backed by useThemeStore.
 * Drop into navbar or any header.
 */
import { Sun, Moon } from 'lucide-react';
import { useThemeStore } from '../stores/themeStore';

interface Props {
  size?: number;
  className?: string;
}

const ThemeToggle: React.FC<Props> = ({ size = 18, className = '' }) => {
  const { theme, toggle } = useThemeStore();
  const isDark = theme === 'dark';
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      className={className}
      style={{
        background: 'transparent',
        border: '1px solid var(--pm-color-border)',
        borderRadius: 999,
        width: 36,
        height: 36,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        color: 'var(--pm-color-text)',
        transition: 'background .15s ease, transform .15s ease',
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLButtonElement).style.background = 'var(--pm-color-surface-2)';
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLButtonElement).style.background = 'transparent';
      }}
    >
      {isDark ? <Sun size={size} /> : <Moon size={size} />}
    </button>
  );
};

export default ThemeToggle;

